<template>
  <div>
    <HomeTopbar v-if="templateId === 100"
                :excelUrl="excelUrl"
                :homeContent="homeContent" />

    <template v-if="templateId === 101 || templateId === 102">
      <!-- 与 type2-style 根选择器一致，样式仅作用于该容器内 -->
      <div class="mrput-home-page">
        <!-- 顶栏：品牌、外链导航、主题切换、移动端汉堡按钮 -->
        <nav class="navbar">
          <router-link to="/home"
                       v-if="templateId === 101">
            <img class="nav-brand"
                 fetchpriority="high"
                 :src="homeContent?.pcImage1"
                 alt="">
          </router-link>
          <ul class="nav-links"
              style="position:absolute;left:50%;transform:translateX(-50%);">
            <li v-for="item in navList"
                :key="item.href">
              <a v-if="item.href.startsWith('http')"
                 :href="item.href"
                 target="_blank"
                 class="nav-btn">
                {{ item.label }}
              </a>
              <router-link v-else
                           class="nav-btn"
                           :to="item.href">
                {{ item.label }}
              </router-link>
            </li>
          </ul>
          <div class="nav-tools">
            <button class="nav-hamburger"
                    @click="toggleMobile"
                    aria-label="Menu"
                    style="outline: none;">
              ☰
            </button>
          </div>
        </nav>

        <el-drawer append-to-body
                   size="100%"
                   :lock-scroll="false"
                   :visible.sync="state.mobileMenuOpen"
                   direction="rtl">
          <div class="mobile-menu open"
               id="mobileMenu">
            <button class="mobile-close"
                    @click="toggleMobile"
                    aria-label="Close">
              ×
            </button>
            <router-link class="nav-link"
                         v-for="item in navList.slice(0, 2)"
                         :key="item.href"
                         :to="item.href"
                         @click="toggleMobile">
              {{ item.label }}
            </router-link>

            <a v-if="navList.length > 2"
               class="nav-link"
               :href="navList[2].href"
               target="_blank"
               @click="toggleMobile">
              {{ navList[2].label }}
            </a>
            <div class="menu-divider"></div>
          </div>
        </el-drawer>
      </div>
    </template>

    <header v-if="templateId === 103"
            data-elementor-type="header"
            data-elementor-id="14"
            class="elementor elementor-14 elementor-location-header"
            data-elementor-post-type="elementor_library">
      <!-- 顶栏：品牌、外链导航、主题切换、移动端汉堡按钮 -->
      <div class="elementor-element elementor-element-3246c11 e-flex e-con-boxed e-con e-parent e-lazyloaded"
           data-id="3246c11"
           data-element_type="container"
           data-e-type="container"
           style="z-index: 100;">
        <div class="e-con-inner">
          <div v-if="homeContent?.pcImage1"
               class="elementor-element elementor-element-9df4a3d elementor-widget__width-initial elementor-widget elementor-widget-image"
               data-id="9df4a3d"
               data-element_type="widget"
               data-e-type="widget"
               data-widget_type="image.default">
            <router-link to="/home">
              <img fetchpriority="high"
                   width="800"
                   height="598"
                   :src="homeContent?.pcImage1"
                   class="elementor-animation-shrink attachment-large size-large wp-image-21172"
                   alt=""
                   sizes="(max-width: 800px) 100vw, 800px">
            </router-link>
          </div>
          <span v-else></span>

          <div class="elementor-element elementor-element-bbc08cc e-con-full elementor-hidden-mobile e-flex e-con e-child"
               data-id="bbc08cc"
               data-element_type="container"
               data-e-type="container">
            <div class="elementor-element elementor-element-f3f735e elementor-icon-list--layout-inline elementor-hidden-mobile elementor-hidden-tablet elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                 data-id="f3f735e"
                 data-element_type="widget"
                 data-e-type="widget"
                 data-widget_type="icon-list.default">
              <ul class="elementor-icon-list-items elementor-inline-items">
                <li v-for="item in navList"
                    :key="item.label"
                    class="elementor-icon-list-item elementor-inline-item">
                  <a v-if="item.href.startsWith('http')"
                     :href="item.href"
                     target="_blank">
                    <span class="elementor-icon-list-text">
                      {{ item.label }}
                    </span>
                  </a>
                  <router-link v-else
                               :to="item.href">
                    <span class="elementor-icon-list-text">
                      {{ item.label }}
                    </span>
                  </router-link>
                </li>
              </ul>
            </div>
          </div>

          <!-- 社交按钮 -->
          <div class="elementor-element elementor-element-ca503a9 elementor-shape-circle elementor-widget-tablet__width-auto elementor-hidden-mobile elementor-grid-0 e-grid-align-center elementor-widget elementor-widget-social-icons"
               data-id="ca503a9"
               data-element_type="widget"
               data-e-type="widget"
               data-widget_type="social-icons.default">
            <!-- 与 Elementor 导出一致：widget-social-icons 的 font-size/间距依赖此层 -->
            <div class="elementor-widget-container">
              <div class="elementor-social-icons-wrapper elementor-grid"
                   role="list">
                <span v-for="(item, idx) in socialList"
                      :key="item.linkAddress || idx"
                      class="elementor-grid-item"
                      role="listitem">
                  <a class="elementor-icon elementor-social-icon"
                     :href="item.linkAddress"
                     target="_blank">
                    <span class="social-icon-html"
                          v-html="item.url" />
                  </a>
                </span>
              </div>
            </div>
          </div>

          <!-- 小屏菜单按钮 -->
          <div class="elementor-element elementor-element-a0f86c0 elementor-widget-mobile__width-initial elementor-hidden-desktop elementor-widget-tablet__width-initial elementor-view-default elementor-widget elementor-widget-icon"
               data-id="a0f86c0"
               data-element_type="widget"
               data-e-type="widget"
               data-widget_type="icon.default">
            <div class="elementor-icon-wrapper">
              <a class="elementor-icon"
                 @click="state.mobileMenu.show = true">
                <svg aria-hidden="true"
                     class="e-font-icon-svg e-fas-th"
                     viewBox="0 0 512 512"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                        d="M149.333 56v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zm181.334 240v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm32-240v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24zm-32 80V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm-205.334 56H24c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm386.667-56H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm0 160H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zM181.333 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24z">
                  </path>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- 小屏弹窗 -->
      <el-drawer append-to-body
                 size="100%"
                 :modal="false"
                 :lock-scroll="false"
                 :visible.sync="state.mobileMenu.show"
                 direction="ltr"
                 custom-class="goods-page__drawer--type4">
        <div class="dialog-widget dialog-lightbox-widget dialog-type-buttons dialog-type-lightbox elementor-popup-modal page-header-dialog"
             id="elementor-popup-modal-1285"
             aria-modal="true"
             role="document"
             tabindex="0"
             style="display: flex"
             @click="state.mobileMenu.show = false">
          <div class="dialog-widget-content dialog-lightbox-widget-content animated"
               @click.stop>
            <a role="button"
               tabindex="0"
               aria-label="Close"
               href="#"
               class="dialog-close-button dialog-lightbox-close-button">
              <svg class="e-font-icon-svg e-eicon-close eicon-close">
                <use xlink:href="#eicon-close">
                </use>
              </svg>
            </a>
            <div class="dialog-header dialog-lightbox-header">
            </div>
            <div class="dialog-message dialog-lightbox-message">
              <nav data-elementor-type="popup"
                   data-elementor-id="1285"
                   class="elementor elementor-1285 elementor-location-popup"
                   data-elementor-settings="{&quot;entrance_animation&quot;:&quot;slideInLeft&quot;,&quot;exit_animation&quot;:&quot;slideInLeft&quot;,&quot;entrance_animation_duration&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:0.2,&quot;sizes&quot;:[]},&quot;a11y_navigation&quot;:&quot;yes&quot;,&quot;timing&quot;:[]}"
                   data-elementor-post-type="elementor_library"
                   style="display: block;">
                <div class="elementor-element elementor-element-9dfecf4 e-con-full e-flex e-con e-parent"
                     data-id="9dfecf4"
                     data-element_type="container"
                     data-e-type="container">
                  <div v-if="homeContent?.pcImage1"
                       class="elementor-element elementor-element-4b511a0 elementor-widget elementor-widget-image"
                       data-id="4b511a0"
                       data-element_type="widget"
                       data-e-type="widget"
                       data-widget_type="image.default">
                    <span>
                      <img width="800"
                           height="598"
                           :src="homeContent?.pcImage1"
                           class="elementor-animation-shrink attachment-large size-large wp-image-21172"
                           alt=""
                           sizes="(max-width: 800px) 100vw, 800px">
                    </span>
                  </div>
                  <div class="elementor-element elementor-element-92d08b4 elementor-align-center elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                       data-id="92d08b4"
                       data-element_type="widget"
                       data-e-type="widget"
                       data-widget_type="icon-list.default">
                    <ul class="elementor-icon-list-items">
                      <li v-for="item in navList"
                          :key="'mobile-nav-' + item.label"
                          class="elementor-icon-list-item">
                        <a v-if="item.href.startsWith('http')"
                           :href="item.href"
                           target="_blank">
                          <span class="elementor-icon-list-text">
                            {{ item.label }}
                          </span>
                        </a>
                        <router-link v-else
                                     :to="item.href">
                          <span class="elementor-icon-list-text">
                            {{ item.label }}
                          </span>
                        </router-link>
                      </li>
                    </ul>
                  </div>

                  <div class="elementor-element elementor-element-56dfdc0 elementor-shape-circle elementor-widget-tablet__width-auto elementor-grid-0 e-grid-align-center elementor-widget elementor-widget-social-icons"
                       data-id="56dfdc0"
                       data-element_type="widget"
                       data-e-type="widget"
                       data-widget_type="social-icons.default">
                    <div class="elementor-social-icons-wrapper elementor-grid"
                         role="list">
                      <span v-for="(item, idx) in socialList"
                            :key="item.linkAddress || idx"
                            class="elementor-grid-item"
                            role="listitem">
                        <a class="elementor-icon elementor-social-icon"
                           :href="item.linkAddress"
                           target="_blank">
                          <span class="social-icon-html"
                                v-html="item.url" />
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
              </nav>
            </div>
            <div class="dialog-buttons-wrapper dialog-lightbox-buttons-wrapper">
            </div>
          </div>
        </div>
      </el-drawer>
    </header>
  </div>
</template>

<script>
import HomeTopbar from '../components/home-topbar.vue'
import '@/views/home/model/home--type4/type4-all.js'

export default {

  name: 'PageHeader',

  components: {
    HomeTopbar
  },

  data() {
    // 头部静态内容统一集中管理，便于后续替换多语言或配置化。
    return {
      state: {
        mobileMenu: {
          show: false,
        },
        platform: {},
        mobileMenuOpen: false,
      },
    }
  },

  computed: {
    excelUrl() {
      return JSON.parse(sessionStorage.getItem('homeData')).excelUrl || ''
    },

    navList() {
      const arr = [
        { href: '/home', label: 'HOME' },
        { href: '/goods', label: 'PRODUCTS' }
      ]

      if (this.excelUrl) {
        arr.push({ href: this.excelUrl, label: 'SPREADSHEET' })
      }

      return arr
    },

    templateId() {
      return JSON.parse(sessionStorage.getItem('homeData')).templateId || ''
    },

    homeContent() {
      return JSON.parse(sessionStorage.getItem('homeData')).homeContent || {}
    },

    socialList() {
      return this.homeContent.links.filter(item => item.enabled === 'Y')
    }
  },

  mounted() {
    const id = this.templateId
    if (id === 101 || id === 102) {
      document.documentElement.style.scrollBehavior = 'smooth'
    }
  },

  beforeDestroy() {
    const id = this.templateId
    if (id === 101 || id === 102) {
      document.documentElement.style.scrollBehavior = ''
    }
  },

  methods: {
    /** 切换移动端全屏菜单，并控制 body 滚动穿透 */
    toggleMobile() {
      this.state.mobileMenuOpen = !this.state.mobileMenuOpen
    },
  }
};
</script>

<!-- 与 home--type2 一致：模块样式仅 .mrput-home-page 下生效，故不用 scoped -->
<style lang="scss">
@import '@/views/home/model/home--type2/styles/type2-style.scss';

.goods-page__drawer--type4 {
  background: transparent !important;

  .el-drawer__header {
    display: none;
  }
}
</style>

<style scoped lang="scss">
@import '@/views/home/model/home--type2/styles/mr-put-you-on-finds-fonts.css';

.nav-link:hover {
  color: var(--primary-color) !important;
}

.nav-hamburger,
.mobile-close {
  border: 1px solid var(--select-border-color);
}

.page-header-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: var(--background-color);
}

/* 内联 SVG 与 img 在导航里对齐尺寸 */
.social-icon-html :deep(svg) {
  display: block;
  height: 32px;
  width: 32px;
}

.elementor-icon-list-text {
  color: var(--select-color) !important;
}

.elementor-icon-list-text:hover {
  color: var(--primary-color) !important;
}

.elementor-icon.elementor-social-icon {
  background-color: var(--primary-color) !important;
}

.elementor-icon.elementor-social-icon:hover {
  background-color: var(--select-color) !important;
}

.dialog-widget-content {
  background: var(--background-color);
}

.elementor-popup-modal .social-icon-html :deep(svg) {
  height: 24px;
  width: 24px;
}

.page-header-dialog {
  position: fixed;
  height: 100vh;
  width: 100%;
  top: 0;
  z-index: 9999;
}

.e-font-icon-svg.e-fas-th {
  fill: var(--select-color) !important;
}

.e-font-icon-svg.e-fas-th:hover {
  fill: var(--primary-color) !important;
}

.nav-link:hover {
  color: var(--primary-color) !important;
}

#elementor-popup-modal-1285 .dialog-widget-content {
  background-color: var(--background-color) !important;
}
</style>